export default __webpack_public_path__ + "static/media/holding-lens.44dd48cf.png";